import { FaInstagram } from 'react-icons/fa';
import { FaFacebook } from 'react-icons/fa';
import { FaLinkedin } from 'react-icons/fa';
import { FaGithub } from 'react-icons/fa';

const data = [
    {
        id: 1,
        link: 'https://www.instagram.com/bidyutranjan',
        icon: <FaInstagram />,
    },
    {
        id: 2,
        link: 'https://www.facebook.com/bidyut.ranjandeka',
        icon: <FaFacebook />,
    },
    {
        id: 3,
        link: 'https://www.linkedin.com/in/bidyut-deka-209595160',
        icon: <FaLinkedin />,
    },
    { id: 4, link: 'https://github.com/Bidyut163', icon: <FaGithub /> },
];

export default data;
